// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19nzx","newExpiryDate":"styles_newExpiryDate__3gc6O","footer":"styles_footer__2IHkQ"};